import React from 'react';
import {Layout} from "antd";
import Sider from "antd/es/layout/Sider";
import SideMenu from "../molecules/menu/SideMenu";
import {Outlet} from "react-router-dom";
import {useSelector} from "react-redux";
import {RootState} from "../../reducers/reducer";

const MenuTemplate = () => {
  const {fullname, phonenumber} = useSelector((state: RootState) => state.profile);
  
  return (<Layout className={"h-screen"}>
    <Sider className={"h-full"}>
      <div className="flex flex-col h-full bg-dark">
        <SideMenu />
        <div className={"flex-1"} />
        <div className={"w-full text-white text-sm p-4"}>
          {fullname}
          <br />
          {phonenumber}
        </div>
      </div>
    </Sider>
    <Layout>
      <Outlet />
    </Layout>
  </Layout>)
};

export default MenuTemplate;
